import React, { useEffect, useState, useCallback } from 'react'
import styled from 'styled-components'
import Button from '../../Tool-kit/Button'
import { Input as BaseInput } from '../../Tool-kit/Input'
import { devices } from '../../Tool-kit/styles/mediaQueries'
import Text from '../../Tool-kit/Typography'
import { toast } from 'react-toast'
import emailValidation from 'utils/emailValidation'
import { useTranslation } from 'react-i18next'
import Loader from 'components/Loader'
import { trackEvent } from 'utils/analytics1'

const Form = styled.form`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  button {
    max-width: 39.5rem;
    padding: 1.5rem;
  }
`

const Input = styled(BaseInput)`
  padding: 1.7rem;
  height: 4.8rem;
  max-width: 39.5rem;

  @media ${devices.phone} {
    width: 100%;
  }
`

const ContactForm = ({ onValidated, status, message }) => {
  const [email, setEmail] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    if (!message) return

    if (status === 'success') {
      if (message.toString() == 'Thank you for subscribing!') {
        toast.success(message.toString())
      } else {
        toast.info(
          'Almost finished... To complete the subscription process, please confirm your email by clicking the link we sent to your email.',
          {
            backgroundColor: 'orange',
            color: '#ffffff'
          }
        )
      }
      trackEvent('Newsletter subscription', 'subscribe')
      setEmail('')
    } else toast.error(message.toString())
  }, [message, status])

  const onChange = useCallback(data => {
    setEmail(data.value)
  }, [])

  const onSubscribe = useCallback(
    e => {
      e.preventDefault()
      if (!email || !emailValidation(email)) {
        toast.error('Please enter a valid email address!')
        return
      }
      onValidated({
        EMAIL: email
      })
    },
    [email, onValidated]
  )
  return (
    <Form onSubmit={onSubscribe}>
      <Text font="caption" color="white" fontSize="2.2rem" mb="1rem">
        {t('c.subscribe')}
      </Text>
      <Input
        placeholder="Email address"
        value={email}
        cbHandler={onChange}
        roundedCorners
      />
      <Button width="100%" roundedCorners disabled={status === 'sending'}>
        {t('c.subscribeButton')}
        {status === 'sending' && (
          <Loader
            style={{
              marginLeft: '1rem'
            }}
          />
        )}
      </Button>
    </Form>
  )
}

export default ContactForm
